module.exports = __webpack_public_path__ + "static/img/refrigerated-delivery.71e5120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/2/refrigerated-delivery.png
// module id = QKsW
// module chunks = 1